import React from "react";
import myBackground from "../assets/sprout.png";

const Contact = () => {
  return (
    <div
      className="relative w-full min-h-screen flex flex-col items-center justify-center p-5"
      style={{
        backgroundImage: `url(${myBackground})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* Dark Overlay for readability */}
      <div className="absolute inset-0 bg-black bg-opacity-50"></div>

      {/* Content Wrapper */}
      <div className="relative z-10 w-full max-w-3xl text-center text-yellow-500">
        <h1 className="text-4xl font-bold mb-6">Contact Us</h1>

        {/* Contact Form */}
        <div className="bg-white bg-opacity-90 shadow-lg rounded-lg p-6">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">Get in Touch</h2>

          <form className="space-y-4">
            <div>
              <label className="block text-gray-600 font-medium">Name</label>
              <input
                type="text"
                className="w-full p-2 border rounded-md"
                placeholder="Enter your name"
              />
            </div>

            <div>
              <label className="block text-gray-600 font-medium">Email</label>
              <input
                type="email"
                className="w-full p-2 border rounded-md"
                placeholder="Enter your email"
              />
            </div>

            <div>
              <label className="block text-gray-600 font-medium">Message</label>
              <textarea
                className="w-full p-2 border rounded-md"
                placeholder="Write your message..."
                rows="4"
              ></textarea>
            </div>

            <button className="bg-green-600 text-white px-4 py-2 rounded-md hover:bg-green-700">
              Send Message
            </button>
          </form>
        </div>

        {/* Google Map */}
        <div className="mt-10 w-full">
          <h2 className="text-2xl font-semibold text-white mb-4">Find Us</h2>
          <div className="rounded-lg overflow-hidden shadow-lg">
            <iframe
              title="Google Map Location"
              className="w-full h-64"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2555.8437086253557!2d121.51343108231734!3d25.05073729365589!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3442a912cf97ee6d%3A0x38b75d81802f9c87!2sNo.%2030%2C%20Section%201%2C%20Chongqing%20N%20Rd%2C%20Datong%20District%2C%20Taipei%20City%2C%20103!5e0!3m2!1sen!2stw!4v1740110074689!5m2!1sen!2stw"
              allowFullScreen
              loading="lazy"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
